export default {
  key: 'system--workspace-project',
  routes: [
    /^\/$/,
    /^\/(login|signin|signup|signup-confirmation|reset-password)(\/|$)/,
    /^\/(tickets|chat|chats|calendar|inbox|epics|teams|meet|documents)(\/|$)/,
  ],
  i18nNamespaces: ['workspace-project'],
  app:     () => import('./app.js').then(m => m.default),
  context: () => import('./context.js').then(m => m.default),
  fetchOnMount: ({ state, sdk }) => {
    return sdk.workspaceProject?.notifications?.unreadCount()
      ?.then(n => { state.notificationsUnread = n })
  },
}
